import { type OutflowContext, OutflowOffers } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers.types';
import { Reasons } from 'reactApp/ui/PollPopup/PollPopup.constants';

export function manyOffers() {
    return [
        OutflowOffers.ARE_YOU_SURE,
        OutflowOffers.SURVEY,
        ({ choice }: OutflowContext) => {
            switch (choice) {
                case Reasons.FREE_ENOUGH:
                    return [OutflowOffers.UNLIMITED_AUTOUPLOAD, OutflowOffers.PAUSE, OutflowOffers.DISCOUNT];
                case Reasons.ANOTHER_CLOUD:
                    return [OutflowOffers.UNLIMITED_AUTOUPLOAD, OutflowOffers.PAUSE];
                case Reasons.HIGH_PRICE:
                    return [OutflowOffers.FAMILY, OutflowOffers.DISCOUNT];
                case Reasons.ANOTHER_PRODUCT:
                case Reasons.TECH_PROBLEMS:
                default:
                    return [OutflowOffers.UNLIMITED_AUTOUPLOAD];
            }
        },
        OutflowOffers.CAPTCHA,
    ];
}
